var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('img',{attrs:{"src":require("../../assets/loading.svg"),"alt":"Loading"}}),_c('h4',[_vm._v("Mohon menuggu")])])}]

export { render, staticRenderFns }